import { inject as service } from '@ember/service';
import EmberObject from '@ember/object';
import { difference } from 'lodash';
import Route from 'mewe/routes/route';

import { Theme, FeedTypes, WrapperScope } from 'mewe/constants';
import { ds } from 'mewe/stores/ds';
import { fetchFeaturedAll, fetchInvitations, fetchPagesById } from 'mewe/fetchers/fetch-pages';
import { fetchFeedPages, getPagesFeed } from 'mewe/fetchers/fetch-feed';
import { fetchWrappers } from 'mewe/fetchers/fetch-wrappers';
import { fetchTellers } from 'mewe/fetchers/fetch-stories';

export default Route.extend({
  theme: Theme.PAGES,

  stories: service(),
  dynamicDialogs: service(),

  queryParams: {
    tag: {
      refreshModel: true,
    },
  },

  beforeModel: function (transition) {
    let { to: toRouteInfo } = transition;

    this.tag = toRouteInfo.queryParams.tag || null;

    fetchWrappers(WrapperScope.PAGE);

    fetchFeedPages({ hashtag: this.tag });

    fetchInvitations();

    fetchFeaturedAll();

    fetchTellers().then(() => {
      ds.tellers.items.forEach((el) => this.stories.preload(el.get('stories')[0]));
    });

    Promise.all([
      ds.featuredAll.promise,
      ds.followed.promise,
      getPagesFeed({ hashtag: toRouteInfo.queryParams.tag }).promise,
      ds.wrappers.promise,
    ]).then((values) => {
      let wrappersIds = values[3].wrappers.map((el) => el.id);

      let featuredPages = values[0].pages && values[0].pages.map((e) => e.id);
      let followedPages = values[1] && values[1].pages && values[1].pages.map((e) => e.page.id);
      let feedPages = values[2].pages && values[2].pages.map((e) => e.id);

      const fetchedPagesIds = [].concat(featuredPages, followedPages, feedPages);
      const missingPages = difference(wrappersIds, fetchedPagesIds);

      if (missingPages.length) {
        fetchPagesById(missingPages.join(','));
      }
    });
  },

  model: function (params) {
    return EmberObject.create({
      app: this.modelFor('app'),
      invitations: ds.invitations,
      followed: ds.followed,
      featured: ds.featuredAll,
      feed: getPagesFeed(FeedTypes.PAGES, { hashtag: params.tag }),
      hashTag: params.tag,
      wrappers: ds.wrappers,
      wrappersScope: WrapperScope.PAGE,
      pages: ds.pages,
      tellers: ds.tellers,
      tag: this.tag,
    });
  },

  actions: {
    willTransition() {
      // when leaving hashTag filtered feed clean ht (SG-27918)
      if (this.tag) this.controller.set('tag', null);
    },

    refetchFeed() {
      fetchFeedPages();
    },

    didTransition() {
      this.dynamicDialogs.closeAll();
      return true;
    },
  },
});
